import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { ReactNode } from 'react';

const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

interface StaggerFadeInProps {
  delay?: number;
  duration?: number;
  children: ReactNode;
}

export function StaggerFadeIn({
  delay = 0,
  duration = 600,
  children,
}: StaggerFadeInProps) {
  return (
    <Box
      sx={{
        animation: `${fadeSlideUp} ${duration}ms ease-out ${delay}ms both`,
      }}
    >
      {children}
    </Box>
  );
}
